import { render, staticRenderFns } from "./PropositionContratPorteuse.vue?vue&type=template&id=45ef9010&"
import script from "./PropositionContratPorteuse.vue?vue&type=script&lang=js&"
export * from "./PropositionContratPorteuse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports